import {
  TableContainer,
  Paper,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Switch,
  Tooltip,
  IconButton,
} from "@mui/material";
import ListHeader from "./ListHeader";
import { IListEmails } from "../../interfaces/order";
import { CUSTOMIZATION_PERMISSION } from "../../utils/constants";
import { usePermission } from "../../customHooks/usePermission";

const COLUMNS = [
  { label: "Estados logísticos" },
  { label: "Tipo" },
  { label: "Acciones" },
  { label: "Envío de notificación" },
];

const ListEmails = ({
  emailTemplates,
  handleSelectedAction,
  toggledDisabledStatuses,
  handleToggleDisableStatus,
  readonlyStatuses = [],
  isEditRestricted = false,
}: IListEmails) => {
  const { can_write } = usePermission(CUSTOMIZATION_PERMISSION);

  const getActionsByPermission = () => {
    const view_action = { label: "Ver", name: "view", icon: "visibility" };
    if (isEditRestricted) return [view_action];
    const edit_action = { label: "Editar", name: "edit", icon: "brush" };
    return can_write ? [view_action, edit_action] : [view_action];
  };
  return (
    <TableContainer component={Paper} className="br-20 bg-light">
      <Table>
        <ListHeader columns={COLUMNS} />
        <TableBody>
          {emailTemplates.map((template) => {
            return (
              <TableRow key={template.id}>
                <TableCell className="p-l-20" width="40%">
                  {template.label}
                </TableCell>
                <TableCell width="30%">{template.type}</TableCell>
                <TableCell width="13%">
                  {getActionsByPermission().map(({ name, label, icon }) => (
                    <Tooltip key={name} arrow title={label} placement="top">
                      <IconButton
                        size="small"
                        color="primary"
                        onClick={() =>
                          handleSelectedAction(name, template)
                        }
                      >
                        <span className="material-symbols-rounded">{icon}</span>
                      </IconButton>
                    </Tooltip>
                  ))}
                </TableCell>
                <TableCell width="18%">
                  {can_write ? (
                    (() => {
                      const isBlocked = readonlyStatuses.includes(template.status);
                      return (
                        <Tooltip
                          arrow
                          title={isBlocked ? "Configurado por el Marketplace" : ""}
                          placement="top"
                        >
                          <span>
                            <Switch
                              size="small"
                              disabled={isBlocked}
                              checked={
                                typeof toggledDisabledStatuses[template.status] ===
                                "undefined"
                                  ? !template.disabled
                                  : !toggledDisabledStatuses[template.status]
                              }
                              onChange={(_, checked) =>
                                handleToggleDisableStatus(template.status, checked)
                              }
                            />
                          </span>
                        </Tooltip>
                      );
                    })()
                  ) : (
                    <>{template.disabled ? "Deshabilitado" : "Habilitado"}</>
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ListEmails;
